import type { EventRow, EventsListResponse } from '../api/events';

/** All events (active, past, void) sorted by name for task pickers. */
export function mergeEventChoices(data: EventsListResponse | EventRow[]): EventRow[] {
  const list = Array.isArray(data)
    ? data
    : [...data.active, ...data.past, ...data.void];
  return [...list].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}

export function eventIdForProject(projectId: number | null, events: EventRow[]): number | null {
  if (projectId == null) return null;
  const ev = events.find((e) => e.project_id === projectId);
  return ev?.id ?? null;
}

export function eventForProject(projectId: number | null, events: EventRow[]): EventRow | null {
  if (projectId == null) return null;
  return events.find((e) => e.project_id === projectId) ?? null;
}
